import { sendDwh } from 'reactApp/utils/ga';

export const sendFreemiumConnectedBannerDwh = (action: 'show' | 'click', name: string) => {
    sendDwh({
        eventCategory: 'banner',
        action,
        dwh_enabled: true,
        dwhData: {
            name,
        },
    });
};
